import { call, put, select, race, delay } from "redux-saga/effects";
import { actions as mobileInsuranceActions } from "@/reducers/mobile-insurance-reducer";
import { mobileInsuranceNormalizer } from "@/utils/normalizers/get-mobile-insurance";

const contextStore = (state) => state.main.context;

export function* getMobileInsurance({ data }) {
  const { productOffering, capacity, offerType, productType } = data;
  try {
    const context = yield select(contextStore);

    const { getDeviceInsurance: getDeviceInsurancePromise } = yield import("@/adabyron/abs-layer/get-device-insurance");

    const { response, timeout } = yield race({
      response: call(getDeviceInsurancePromise, { productOffering, capacity, offerType, productType, context }),
      timeout: delay(3000),
    })

    if (timeout) {
      console.log("Timeout 3s en getMobileInsurance");
      yield put(mobileInsuranceActions.getMobileInsuranceError());
      return null;
    }

    // const response = mockGetItem;
    const responseNormalizer = mobileInsuranceNormalizer(response);

    yield put(mobileInsuranceActions.getMobileInsuranceSuccess(responseNormalizer));
  } catch (error) {
    console.log("getItem Error", error);
    yield put(mobileInsuranceActions.getMobileInsuranceError());
  }
}
